/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {
});

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dgc-visual-hero, .dgc-collection-campaign').forEach((section) => {
    const wrapper = section.closest('.shopify-section');
    if (wrapper) wrapper.classList.add('dgc-full-bleed-section');
  });
});
